import { createApp } from 'vue'
import MapSearch from './MapSearch.vue'
import { createPinia } from 'pinia'
const pinia = createPinia()

createApp(MapSearch)
    .use(pinia)
    .mount('#map-search')
